import { Subscription } from "rxjs";
import { Component, OnInit, Input, EventEmitter, Output, SimpleChanges, OnChanges } from "@angular/core";
import { AbstractControl, FormControl, FormGroup, ValidationErrors, Validators } from "@angular/forms";
import {
    BaseGroupType,
    CommonHierarchyDropdownData,
    DataItem,
    ETLBasefeed,
    ETLReportingSetDropdownOptions,
    ETLReportingSetFlowbuilderModules,
    ETLReportingSetJoinedFeedsList,
    ETLReportingSetReturnTypes,
    ETLReportingSetSimpleFieldReturnOptions,
    ETLSimpleFieldType,
    HierarchyGroupName,
    HierarchyItem,
    PERMISSION
} from "../../../cxone-etl-reporting-set.model";
import { OnDestroy } from "cv-ng-metadata/core";
import { CVLocalizationService } from "src/app/reusables/services/cv-localization.service";
import { CxoneEtlReportingSetService } from "../../../cxone-etl-reporting-set.service";
import { ToastrManager } from "@niceltd/cxone-components/toastr";
import moment from "moment";
import { DatePipe } from "@angular/common";

@Component({
    selector: "cv-cxone-reporting-set-simple-field",
    templateUrl: "./cxone-reporting-set-simple-field.component.html",
    styleUrls: ["./cxone-reporting-set-simple-field.component.scss"],
})
export class CxoneReportingSetSimpleFieldComponent implements OnInit, OnChanges, OnDestroy {
    @Input() reportingSetJoinedFeedsList: ETLReportingSetJoinedFeedsList[] = [];
    @Input() feedName = "";
    @Input() returnType: ETLReportingSetDropdownOptions;
    @Output() back = new EventEmitter();
    @Output() addChilds = new EventEmitter();
    @Output() formChanged = new EventEmitter();
    @Output() formNotChanged = new EventEmitter();

    @Output() sendReturnTypeValue = new EventEmitter();
    @Input() returnTypeChange: boolean;
    simpleFeedOptionList: ETLReportingSetDropdownOptions[] = [];
    _parentData: any;
    _returnTypeOptions: ETLReportingSetDropdownOptions[];
    public simpleFieldType: ETLSimpleFieldType;
    public feednamesList: ETLBasefeed[] = [];
    public basefeedOptions: ETLBasefeed[];
    public basefeed = "";
    public useNowLabelTxt = `Use "Now"`;
    protected selectFeedVal = "";
    public employeeContactClickedField = '';
    // will be false if employee/contact group is clicked for editing purpose
    public newGroupCreated = true;
    public isNullCheckboxVisible = true;
    public simpleFieldReturnType: string | number;
    private group: string;
    public defaultDate = new Date();
    public returnTypePlaceholderText = '';
    public returnPlaceholderText = '';
    public feedPlaceholderText = '';
    public fieldPlaceholderText = '';
    public defaultValuePlaceholderText = '';
    primaryFeedOptions: ETLReportingSetDropdownOptions[] = [];
    secondaryFeedOptions: ETLReportingSetDropdownOptions[] = [];
    public defaultValueLength = 0;
    subscription: Subscription = new Subscription();
    private formValueChangeSubscription: Subscription = new Subscription();
    private returnTypeChangeSubscription: Subscription = new Subscription();
    private _subscriptions: Subscription[] = [];
    private isAdvanced = false;
    isDisableDate = false;
    tempDefaultValue = "";
    hierarchyGroupName = HierarchyGroupName.COMPANY;
    hierarchyDefData = [];

    @Input() permissions: string[];
    public canEditLocked = false;
    public canEdit = false;

    @Input() set parentData(data) {
        if (this.simpleFieldForm) {
            this.defaultValueControl.reset();
            if (!this.DisableEdit)
                this.defaultValueControl.enable();
            if (this.IsNullControl) this.IsNullControl.setValue(false);
            if (this.UseNowControl) this.UseNowControl.setValue(false);
        }        
        this._parentData = null;
        if (data) {
            this._parentData = data;
            if (data.hasOwnProperty("simpleFieldType")) {
                // transformdata for hierarchy join
                const FieldName = data.simpleFieldType.Field?.Name;
                const matchingItem = CommonHierarchyDropdownData.find(item => item.Name === FieldName);
                if (matchingItem) {
                    data.simpleFieldType.Field = matchingItem;
                }
                this.newGroupCreated = true;
                this.isAdvanced = false;
                this.simpleFieldForm.patchValue(data.simpleFieldType);
                this._parentData.simpleFieldType['isValid'] = this.simpleFieldForm.valid;
                this.parentData.isValid = this.simpleFieldForm.valid;
            } else {
                this.newGroupCreated = true;
                this.isAdvanced = true;
                this.simpleFieldForm.get('return').reset();
            }
            const joinedFeeds = this.reportingSetJoinedFeedsList.map(
                (item, index) => ({ id: index + 1, label: item.joinedFeedName, joinID: item.JoinID })
            );
            joinedFeeds.forEach((item) => {
                const match = this.simpleFeedOptionList.find((aItem) => {
                    return aItem.id === item.id && aItem.label === item.label;
                });
                if (!match) {
                    this.simpleFeedOptionList.push(item);
                }
            });
            this.simpleFeedOptionList = [...this.simpleFeedOptionList];
        }
        this.initializeSimpleFields();
    }

    @Input() set returnTypeOptions(data: ETLReportingSetDropdownOptions[]) {
        this._returnTypeOptions = data;
        if (typeof this._parentData.simpleFieldType?.expectedReturnType === 'number' || typeof this._parentData.simpleFieldType?.expectedReturnType === 'string') {
            this.simpleFieldForm.get('expectedReturnType').patchValue(this._returnTypeOptions[this._parentData.simpleFieldType?.expectedReturnType]);
        }
        if (this._parentData && !this._parentData.simpleFieldType) {
            this.simpleFieldForm.get('expectedReturnType').patchValue(this.returnType);
            this.simpleFieldReturnType = this.returnType?.id;
        }
    }

    @Input() set currentSelection(selection: string) {
        this.group = selection;
        this.isNullCheckboxVisible = selection !== ETLReportingSetFlowbuilderModules.EMPLOYEE_GROUP &&
            selection !== ETLReportingSetFlowbuilderModules.CONTACT_GROUP && selection !== ETLReportingSetFlowbuilderModules.EXCLUDE_IF;

        if ((this.group === ETLReportingSetFlowbuilderModules.CONTACT_GROUP) || (this.group === ETLReportingSetFlowbuilderModules.EMPLOYEE_GROUP)) {
            this.simpleFieldForm.get("expectedReturnType").disable();
        }

        if (this._parentData.uniqueId) {
            if (this._parentData.uniqueId === 1 && this._parentData.type === ETLReportingSetFlowbuilderModules.TYPE_SIMPLE) {
                if (!this.DisableEdit)
                    this.simpleFieldForm.get('expectedReturnType').disable();
            } else {
                if (!this.DisableEdit)
                    this.simpleFieldForm.get('expectedReturnType').enable();
            }
        }
    }

    get parentData() {
        return this._parentData;
    }

    simpleFieldForm = new FormGroup({
        expectedReturnType: new FormControl(),
        return: new FormControl(),
        JoinID: new FormControl(),
        IsNull: new FormControl(),
        DefaultValue: new FormControl(null, [
            this.customDefaultValueValidator(this.getLocalizationString.bind(this))
        ]),
        Field: new FormControl(),
        UseNow: new FormControl()
    });
    returnOptions: ETLReportingSetDropdownOptions[];
    protected readonly eReportingSetSimpleFieldReturnOptions =
        ETLReportingSetSimpleFieldReturnOptions;
    protected readonly eReportingSetReturnTypes = ETLReportingSetReturnTypes;

    constructor(
        private cvLocalizationService: CVLocalizationService,
        public cxoneEtlReportingSet: CxoneEtlReportingSetService,
        private toasterManager: ToastrManager,
        private datePipe: DatePipe
    ) { }

    get return(): ETLReportingSetDropdownOptions {
        return this.simpleFieldForm.get("return").value;
    }

    get IsNull() {
        let isNull = this.simpleFieldForm.get("IsNull");
        return isNull && isNull.value;
    }

    get IsNullControl() {
        return this.simpleFieldForm.get("IsNull");
    }

    get defaultValue() {
        return this.simpleFieldForm.get("DefaultValue").value;
    }

    get defaultValueControl() {
        return this.simpleFieldForm.get("DefaultValue");
    }

    get UseNow() {
        let useNow = this.simpleFieldForm.get("UseNow");
        return useNow && useNow.value;
    }

    get UseNowControl() {
        return this.simpleFieldForm.get("UseNow");
    }

    get DisableEdit() {
        return !this.canEdit || (this.cxoneEtlReportingSet.getReportingSetData()?.IsEditable !== undefined && !this.cxoneEtlReportingSet.getReportingSetData()?.IsEditable && !this.canEditLocked)
    }
    async ngOnInit() {
        this.simpleFieldForm.get('expectedReturnType').disable();
        this.simpleFieldForm.get('return').disable();
        this.simpleFieldForm.get('JoinID').disable();
        this.simpleFieldForm.get('Field').disable();
        this.simpleFieldForm.get('DefaultValue').disable();
        this.simpleFieldForm.get('IsNull').disable();
        this.simpleFieldForm.get('UseNow').disable();
        await this.loadLocalization();
        this.updateControls();
        await this.loadBasefeedData();
        this.initializeFeedDropdown();
        this.newGroupCreated && this.selectDefaultDropdownOption();
        this.initializeSimpleFeedObjectInOutputForm();

        this.canEditLocked = this.permissions?.includes(PERMISSION.ADMIN);
        this.canEdit = this.permissions?.includes(PERMISSION.EDIT);

        if (!this.DisableEdit) {
            this.simpleFieldForm.get('expectedReturnType').enable();
            this.simpleFieldForm.get('return').enable();
            this.simpleFieldForm.get('JoinID').enable();
            this.simpleFieldForm.get('Field').enable();
            this.simpleFieldForm.get('DefaultValue').enable();
            this.simpleFieldForm.get('IsNull').enable();
            this.simpleFieldForm.get('UseNow').enable();
        }
        

        this._subscriptions.push(this.cxoneEtlReportingSet.getData().subscribe((value) => {
            this.employeeContactClickedField = value?.selectedSectionName;
            this.handleDefaultValues(value?.isNew);
        }));

        if (this._parentData) {
            if (this._parentData.hasOwnProperty("simpleFieldType")) {
                if (this._parentData.simpleFieldType && typeof this._parentData.simpleFieldType.expectedReturnType !== 'object' && this._parentData.simpleFieldType.expectedReturnType !== null) {
                    // while sending in API it was number instead of object which comes as its so this condition
                    this.simpleFieldForm.get('expectedReturnType').patchValue(this._returnTypeOptions[this._parentData.simpleFieldType.expectedReturnType]);
                } else {
                    this.simpleFieldForm.get('expectedReturnType').patchValue(this._parentData.simpleFieldType.expectedReturnType);
                }
                if (!this._parentData.simpleFieldType.hasOwnProperty('expectedReturnType')) {
                    this.simpleFieldForm.get('expectedReturnType').patchValue(this.returnType);
                    this.simpleFieldReturnType = this.simpleFieldForm.get('expectedReturnType').value.id;
                } else {
                    this.simpleFieldReturnType = !this._parentData.simpleFieldType.expectedReturnType?.id ? this._parentData.simpleFieldType.expectedReturnType : this._parentData.simpleFieldType.expectedReturnType.id;
                }
            };

            this._subscriptions.push(this.simpleFieldForm.get("JoinID").valueChanges.subscribe(() => {
                this.simpleFieldForm.patchValue({
                    Field: ''
                });
            }));

            // added for initial 
            if (this._parentData.simpleFieldType.IsNull) {
                this.toggleNullCheckbox();
                this.handleNullChange();
            } else if (this._parentData.simpleFieldType.UseNow) {
                this.toggleUseNowCheckbox();
                this.handleUseNowChange();
            }
            this.returnTypeChangeEvent({ selected: this.simpleFieldForm.get('expectedReturnType').value, isManual: true });
        }
    }

    handleDefaultValues(isNew = false) {
        if (isNew) {
            this.simpleFieldForm.get('return').patchValue(this.returnOptions[0]);
        }
        if ((this.return?.id === ETLReportingSetSimpleFieldReturnOptions.DEFAULT_VALUE || this.return?.id === ETLReportingSetSimpleFieldReturnOptions.SPECIFIC_FIELD_AND_DEFAULT_VALUE) && this.employeeContactClickedField === HierarchyGroupName.COMPANY) {
            let defaultValue = this._parentData?.simpleFieldType.DefaultValue !== "null" ? this._parentData?.simpleFieldType.DefaultValue : 1;
            this.simpleFieldForm.patchValue({
                DefaultValue: `${defaultValue}`
            });
        } else if (this.employeeContactClickedField !== HierarchyGroupName.COMPANY && this.employeeContactClickedField) {
            let defaultValue = this._parentData.hasOwnProperty('simpleFieldType') && this._parentData.simpleFieldType.DefaultValue ? this._parentData.simpleFieldType.DefaultValue : 0;
            this.simpleFieldForm.patchValue({ DefaultValue: `${defaultValue}` });
        } else if (!this.employeeContactClickedField && this.simpleFieldReturnType === this.eReportingSetReturnTypes.TRUE_FALSE) {
            this.simpleFieldForm.patchValue({ DefaultValue: String(this._parentData?.simpleFieldType.DefaultValue) || 'false' });
        } else if (!this.employeeContactClickedField && this.simpleFieldReturnType === this.eReportingSetReturnTypes.DATE) {
            if (this.IsNull || this.UseNow) {
                this.defaultDate = new Date();
            } else {
                let defaultDateTxt = this._parentData.simpleFieldType.DefaultValue ? this._parentData.simpleFieldType.DefaultValue : "";
                const isDate = this.isValidDateObject(new Date(defaultDateTxt));
                // Get the current date in UTC
                this.defaultDate = isDate ? new Date(defaultDateTxt) : new Date();
            }
            this.simpleFieldForm.patchValue({ DefaultValue: this.defaultDate });
        } else if (this.simpleFieldReturnType === this.eReportingSetReturnTypes.TEXT) {
            this.simpleFieldForm.patchValue({ DefaultValue: this._parentData.simpleFieldType.DefaultValue });
        }

    }

    ngOnChanges(changes: SimpleChanges): void {
        this.simpleFieldForm.get('expectedReturnType').patchValue(this.returnType);
        if (this.returnTypeChangeSubscription) {
            this.returnTypeChangeSubscription.unsubscribe();
        }
        this.returnTypeChangeSubscription = this.simpleFieldForm.get("expectedReturnType").valueChanges.subscribe(() => {
            if (this.simpleFieldType && this.simpleFieldType['expectedReturnType']) {
                this.simpleFieldReturnType = this.simpleFieldForm.get('expectedReturnType').value.id ? this.simpleFieldForm.get('expectedReturnType').value.id : this.simpleFieldType['expectedReturnType'];
                // add for default value initial
                if (this.parentData.simpleFieldType?.IsNull) {
                    this.toggleNullCheckbox();
                    this.handleNullChange();
                } else if (this.parentData.simpleFieldType?.UseNow) {
                    this.toggleUseNowCheckbox();
                    this.handleUseNowChange();
                } else {
                    if (this.simpleFieldReturnType === this.eReportingSetReturnTypes.WHOLE_NUMBER || this.simpleFieldReturnType === this.eReportingSetReturnTypes.DECIMAL_NUMBER) {
                        if (!this.simpleFieldForm.get('DefaultValue')?.['defaultValue']) {
                            if (this.employeeContactClickedField === HierarchyGroupName.COMPANY) {
                                let defaultValue = this._parentData.hasOwnProperty('simpleFieldType') && this._parentData.simpleFieldType.DefaultValue ? this._parentData.simpleFieldType.DefaultValue : 1;
                                this.simpleFieldForm.patchValue({ DefaultValue: `${defaultValue}` });
                            } else if (this.employeeContactClickedField !== HierarchyGroupName.COMPANY && this.employeeContactClickedField) {
                                let defaultValue = this._parentData.hasOwnProperty('simpleFieldType') && this._parentData.simpleFieldType.DefaultValue ? this._parentData.simpleFieldType.DefaultValue : 0;
                                this.simpleFieldForm.patchValue({ DefaultValue: `${defaultValue}` });
                            } else {
                                let defaultValue = this._parentData.hasOwnProperty('simpleFieldType') && this._parentData.simpleFieldType.DefaultValue ? this._parentData.simpleFieldType.DefaultValue : this.simpleFieldForm.get('DefaultValue')?.value;
                                this.simpleFieldForm.patchValue({ DefaultValue: `${defaultValue}` });
                            }
                        }
                    } else if (this.simpleFieldReturnType === this.eReportingSetReturnTypes.DATE && this.return?.id === ETLReportingSetSimpleFieldReturnOptions.DEFAULT_VALUE) {
                        if (this.IsNull || this.UseNow) {
                            this.defaultDate = new Date();
                        } else {
                            const date = this._parentData.hasOwnProperty('simpleFieldType') && this._parentData.simpleFieldType.DefaultValue ? this._parentData.simpleFieldType.DefaultValue : this.defaultDate;
                            const isDate = this.isValidDateObject(new Date(date));
                            this.defaultDate = isDate ? new Date(date) : new Date();
                        }
                        this.simpleFieldForm.patchValue({ DefaultValue: this.defaultDate });
                    } else if (this.simpleFieldReturnType === this.eReportingSetReturnTypes.TRUE_FALSE && this.return?.id === ETLReportingSetSimpleFieldReturnOptions.DEFAULT_VALUE) {
                        this.simpleFieldForm.patchValue({ DefaultValue: String(this._parentData?.simpleFieldType?.DefaultValue) || 'false' });
                    } else {
                        let defaultValue = this._parentData.hasOwnProperty('simpleFieldType') && this._parentData.simpleFieldType?.DefaultValue ? this._parentData.simpleFieldType.DefaultValue : this.simpleFieldForm.get('DefaultValue')?.value;
                        this.simpleFieldForm.patchValue({ DefaultValue: `${defaultValue}` })
                    }
                }
            }
        });
    }

    public initializeSimpleFeedObjectInOutputForm() {
        if (this.parentData) {
            this.parentData.isValid = this.parentData?.isValid || false;
            if (this.formValueChangeSubscription) {
                this.formValueChangeSubscription.unsubscribe();
            }
            this.formValueChangeSubscription = this.simpleFieldForm.valueChanges.subscribe(() => {
                this.simpleFieldType = {
                    return: this.simpleFieldForm.value.return || {},
                    JoinID: this.simpleFieldForm.value.JoinID || {},
                    IsNull: this.IsNull,
                    UseNow: this.UseNow,
                    ...this.simpleFieldForm.value
                };
                // value of true or false from control comes as string
                let defaultValue = this.simpleFieldForm.get('DefaultValue').value;
                if (defaultValue === 'true' || defaultValue === 'false') {
                    const valueAsBoolean = defaultValue === 'true';
                    defaultValue = valueAsBoolean;
                }
                // when the form value undefined
                if (defaultValue === 'undefined' || !defaultValue) {
                    if (this.simpleFieldReturnType === this.eReportingSetReturnTypes.WHOLE_NUMBER && this.employeeContactClickedField === HierarchyGroupName.COMPANY) {
                        defaultValue = 1;
                    } else if (this.simpleFieldReturnType === this.eReportingSetReturnTypes.WHOLE_NUMBER && (this.employeeContactClickedField && this.employeeContactClickedField !== HierarchyGroupName.COMPANY)) {
                        defaultValue = 0;
                    }
                }
                this.simpleFieldType['isValid'] = this.simpleFieldForm.valid;
                this.simpleFieldType['expectedReturnType'] = this.simpleFieldForm.get('expectedReturnType').value ? this.simpleFieldForm.get('expectedReturnType').value.id : this._parentData?.simpleFieldType?.expectedReturnType;
                this.simpleFieldType['DefaultValue'] = this.simpleFieldForm.get('DefaultValue').value === 'null' ? null : defaultValue;
                this.parentData['simpleFieldType'] = this.simpleFieldType;
                this.parentData.isValid = this.simpleFieldForm.valid;
                if (this.simpleFieldForm.value.IsNull === true) {
                    this.parentData.nameForTree = 'NULL';
                    this.parentData.name = 'NULL';
                } else if (this.simpleFieldForm.value.return?.id === 1) {
                    const simpleName = this.simpleFieldForm.value?.Field?.Name || "Simple";
                    this.parentData.nameForTree = simpleName;
                    this.parentData.name = simpleName != 'Simple' ? "Simple: [" + simpleName + "]" : simpleName;
                } else {
                    let simpleName = this.simpleFieldForm.get('DefaultValue').value !== 'null' ? '"' + defaultValue?.toString().toUpperCase() + '"' : 'Simple';
                    const isDefined = simpleName !== undefined && simpleName !== null && simpleName !== '';
                    const isValidDate = isDefined && !isNaN(new Date(simpleName).getTime());

                    simpleName = (
                        this.simpleFieldReturnType === this.eReportingSetReturnTypes.DATE &&
                        isValidDate
                    )
                        ? this.datePipe.transform(simpleName, 'mediumDate')
                        : simpleName;
                    this.parentData.nameForTree = simpleName;
                    if (this.simpleFieldForm.value?.Field?.Name && this.return?.id === ETLReportingSetSimpleFieldReturnOptions.SPECIFIC_FIELD_AND_DEFAULT_VALUE) {
                        this.parentData.name = this.simpleFieldForm.value?.Field?.Name;
                    } else {
                        this.parentData.name = "Simple: " + simpleName;
                    }
                }
                if (this.simpleFieldForm.dirty) {
                    this.formChanged.emit(this.parentData);
                    sendMessageCXOne({ hasNonSavedChanges: true });
                } else {
                    this.formNotChanged.emit(this.parentData);
                }
            });
        }
    }

    public initializeFeedDropdown(): void {
        let basefeedObj = { id: 0, label: this.feedName, joinID: -1 };
        this.primaryFeedOptions = [basefeedObj, ...this.simpleFeedOptionList];
    }

    public selectDefaultDropdownOption() {
        if (this.return && this._parentData?.simpleFieldType && !this.isAdvanced) {
            if (this.return?.id === ETLReportingSetSimpleFieldReturnOptions.SPECIFIC_FIELD_AND_DEFAULT_VALUE || this.return?.id === ETLReportingSetSimpleFieldReturnOptions.SPECIFIC_FIELD) {
                const joinName = this._parentData?.simpleFieldType?.Field?.joinName ? this._parentData?.simpleFieldType.Field.joinName : this.simpleFieldForm.get('JoinID').value.label;
                let index = this.primaryFeedOptions.findIndex(item => item.label === joinName);
                index = index !== -1 ? index : 0;
                this.selectFeedVal = this.primaryFeedOptions[index].label;
                this.simpleFieldForm.patchValue({
                    return: this.simpleFieldForm.get('return').value ? this.simpleFieldForm.get('return').value : this.returnOptions[0],
                    JoinID: this.primaryFeedOptions[index],
                    Field: this._parentData?.simpleFieldType.Field
                });
            }
        } else {
            this.selectFeedVal = this.primaryFeedOptions[0].label;
            this.simpleFieldForm.patchValue({
                return: this.simpleFieldForm.get('return').value ? this.simpleFieldForm.get('return').value : this.returnOptions[0],
                JoinID: this.primaryFeedOptions[0],
            });
        }
        if (this._parentData && this._parentData?.simpleFieldType) {
            if (typeof this._parentData.simpleFieldType?.expectedReturnType === 'number' || typeof this._parentData.simpleFieldType?.expectedReturnType === 'string') {
                this.simpleFieldForm.get('expectedReturnType').patchValue(this._returnTypeOptions[this._parentData.simpleFieldType?.expectedReturnType]);
            } else {
                if (this._parentData.simpleFieldType.expectedReturnType !== undefined) {
                    this.simpleFieldForm.get('expectedReturnType').patchValue(this._returnTypeOptions[this._parentData.simpleFieldType.expectedReturnType?.id]);
                }
            }
            this.simpleFieldReturnType = this.simpleFieldForm.get('expectedReturnType').value.id;
        }
        this.returnTypeChangeEvent({ selected: this.simpleFieldForm.get('expectedReturnType').value, isManual: true });
        this.initializeSimpleFeedObjectInOutputForm();
    }

    public initializeReturnOptions(): void {
        this.returnOptions = [
            {
                id: ETLReportingSetSimpleFieldReturnOptions.SPECIFIC_FIELD,
                label: this.getLocalizationString("Specific_Field", "Specific Field"),
            },
            {
                id: ETLReportingSetSimpleFieldReturnOptions.DEFAULT_VALUE,
                label: this.getLocalizationString("Default_Value", "Default Value"),
            },
            {
                id: ETLReportingSetSimpleFieldReturnOptions.SPECIFIC_FIELD_AND_DEFAULT_VALUE,
                label: this.getLocalizationString("Specific_Field_And_Default_Value", "Specific Field And Default Value")
            },
        ];
        // if emp or con group remove the specific field
        if ((this.group === ETLReportingSetFlowbuilderModules.CONTACT_GROUP) || (this.group === ETLReportingSetFlowbuilderModules.EMPLOYEE_GROUP) || (this.group === ETLReportingSetFlowbuilderModules.EXCLUDE_IF)) {
            this.returnOptions.shift();
        } else {
            this.returnOptions = [...this.returnOptions];
        }
    }

    async loadLocalization() {
        try {
            await this.cvLocalizationService.GetSection('ETL_Reporting_Set');
        }
        catch {
            console.log('Failed to load localization for ETL_Reporting_Set');
        }
        finally {
            this.returnTypePlaceholderText = this.getLocalizationString("Select_Return_Type", "Select Return Type");
            this.returnPlaceholderText = this.getLocalizationString("Select_Return", "Select Return");
            this.feedPlaceholderText = this.getLocalizationString("Select_Feed", "Select Feed");
            this.fieldPlaceholderText = this.getLocalizationString("Select_Field", "Select Field");
            this.defaultValuePlaceholderText = this.getLocalizationString("Type_Value", "Type value");
        }
    }

    public getLocalizationString(key: string, defaultValue: string): string {
        const baseString = this.cvLocalizationService.getCachedText("ETL_Reporting_Set", key, defaultValue);
        return baseString;
    }

    public async loadBasefeedData() {
        this.basefeedOptions = [];
        try {
            this.feednamesList = await this.cxoneEtlReportingSet.loadBasefeed();
            await this.hierarchyDefinitions();
        }
        catch (error) {
            this.toasterManager?.showToaster('error', this.getLocalizationString('Internal_Server_Error', 'Internal server error. Try again.'));
        }
        finally {
            this.feednamesList = [...this.feednamesList, ...this.hierarchyDefData];
            this.basefeedOptions = [...this.feednamesList];
        }
    }

    public async hierarchyDefinitions() {
        const hierarchyDefData = await this.cxoneEtlReportingSet.hierarchyDefinitions();
        this.hierarchyDefData = hierarchyDefData.data.map(item => {
            const groupType = BaseGroupType[item.BaseGroupType];
            let DataList: DataItem;
            if (groupType === BaseGroupType[0]) {
                DataList = item.MetaData;
            } else {
                DataList = item.MetaData;
            }
            // Return the constructed object
            return {
                dropdownOptions: `${item.PseudoFeedName} (${groupType})`,
                FeedName: `${item.PseudoFeedName}_${item.BaseGroupType}`,
                DataList: DataList,
                CompanyID: item.CompanyID
            };
        });
        this.hierarchyDefData = this.transformData(this.hierarchyDefData);
    }

    public transformData = (data): HierarchyItem[] => {
        return data.map(item => {
            let transformedDataList: DataItem[] = Object.keys(item.DataList).map(key => {
                const dataItem = item.DataList[key];
                return {
                    Name: key,
                    ...dataItem,
                    DataType: dataItem.ExpectedType
                };
            });

            transformedDataList = [...CommonHierarchyDropdownData, ...transformedDataList];
            return {
                ...item,
                DataList: transformedDataList
            };
        });
    };


    initializeSimpleFields() {
        this.loadBasefeedData().then(() => {
            this.initializeFeedDropdown();
            this.initializeReturnOptions();
            this.newGroupCreated && this.selectDefaultDropdownOption();
            this.initializeSimpleFeedObjectInOutputForm();
            if (this._parentData?.isNew) {
                this.simpleFieldForm.markAsDirty();
                this.formChanged.emit(this.parentData);
            } else {
                this.simpleFieldForm.markAsPristine();
                this.formNotChanged.emit(this.parentData);
            }
        });
    }

    public updateControls(): void {
        this.subscription.add(
            this.simpleFieldForm.get("return").valueChanges.subscribe((value: any) => {
                this.removeNonDefaultControls();
                const fieldControl = this.simpleFieldForm.get('Field');
                switch (this.return?.id) {
                    case ETLReportingSetSimpleFieldReturnOptions.SPECIFIC_FIELD:
                        this.defaultValueControl.patchValue('null');
                        fieldControl.setValidators([Validators.required]);
                        this.defaultValueControl.clearValidators();
                        break;
                    case ETLReportingSetSimpleFieldReturnOptions.DEFAULT_VALUE:
                        fieldControl.patchValue({});
                        this.addDefaultValueControls();
                        this.defaultValueControl.setValidators([Validators.required, this.customDefaultValueValidator(this.getLocalizationString.bind(this))]);
                        fieldControl.clearValidators();
                        break;
                    case ETLReportingSetSimpleFieldReturnOptions.SPECIFIC_FIELD_AND_DEFAULT_VALUE:
                        this.addDefaultValueControls();
                        this.defaultValueControl.setValidators([Validators.required, this.customDefaultValueValidator(this.getLocalizationString.bind(this))]);
                        fieldControl.setValidators([Validators.required]);
                        break;
                }
                // Update the validity of the form control after changing validators
                fieldControl.updateValueAndValidity();
                this.defaultValueControl.updateValueAndValidity();
            })
        );
    }

    public addDefaultValueControls(): void {
        if (!this.simpleFieldForm?.contains('IsNull')) {
            this.simpleFieldForm.addControl("IsNull" as any, new FormControl(this.parentData.simpleFieldType.IsNull));
        }
        if (!this.simpleFieldForm?.contains('UseNow')) {
            this.simpleFieldForm.addControl("UseNow" as any, new FormControl(this.parentData.simpleFieldType.UseNow));
        }
        this.simpleFieldForm.addControl('DefaultValue' as any, new FormControl('', Validators.required));
        if (this.parentData.simpleFieldType?.IsNull) {
            this.toggleNullCheckbox();
            this.handleNullChange();
        } else if (this.parentData.simpleFieldType?.UseNow) {
            this.toggleUseNowCheckbox();
            this.handleUseNowChange();
        }
        this.watchDefaultValueChanges();
    }

    public watchDefaultValueChanges(): void {
        this._subscriptions.push(this.simpleFieldForm
            .get("DefaultValue")
            .valueChanges.subscribe((res) => {
                if (this.defaultValueControl.value && (this.simpleFieldReturnType == this.eReportingSetReturnTypes.TEXT) && typeof this.defaultValueControl.value === 'string') {
                    this.defaultValueControl.patchValue(this.defaultValueControl.value.toUpperCase(), { emitEvent: false });
                    this.defaultValueLength = this.defaultValueControl.value.length;
                }
                this.initializeSimpleFeedObjectInOutputForm();
            }));
    }

    removeNonDefaultControls(): void {
        const defaultControls: string[] = ["expectedReturnType", "return", "JoinID", "DefaultValue", "Field", "IsNull", "UseNow"];
        Object.keys(this.simpleFieldForm.controls).forEach((key) => {
            if (!defaultControls.includes(key)) {
                this.simpleFieldForm.removeControl(key as any);
            }
        });
    }

    public ngOnDestroy(): void {
        this._parentData = null;
        if (this.subscription) this.subscription.unsubscribe();
        if (this.formValueChangeSubscription) this.formValueChangeSubscription.unsubscribe();
        if (this.returnTypeChangeSubscription) this.returnTypeChangeSubscription.unsubscribe();
        this._subscriptions.forEach(sub => {
            sub.unsubscribe();
        });
    }

    public addInput() {
        this.addChilds.emit(this.parentData);
    }

    public goBack(): void {
        this.back.emit(this.parentData);
    }

    public notifyValueChanged($event) {
        this.defaultValueControl.setValue(this.convertToDateObj($event));
    }

    public convertToDateObj(date: string) {
        return new Date(date);
    }

    public handleUseNowCheckboxClick($event) {
        const checked = $event.target.checked;
        if (checked) {
            this.defaultValueControl.disable();
            this.defaultValueControl.setValue("{{NOW}}")
        }
        else if (!this.DisableEdit) {
            this.defaultValueControl.enable();
        }
    }

    selectFeedSelection() {
        this.selectFeedVal = this.simpleFieldForm.get('JoinID').value.label || this.selectFeedVal;
        const feedName = this.feedName === this.selectFeedVal ? this.selectFeedVal : this.findObjectByJoinedFeedName(this.reportingSetJoinedFeedsList, this.selectFeedVal)?.feed2.FeedName;
        const dataList = this.basefeedOptions.find(item => item.FeedName === feedName)?.DataList;
        if (dataList) {
            this.secondaryFeedOptions = this.filterObjects(dataList, this.simpleFieldReturnType);
            if (!this._parentData.simpleFieldType?.Field && (this.return?.id === ETLReportingSetSimpleFieldReturnOptions.SPECIFIC_FIELD_AND_DEFAULT_VALUE || this.return?.id === ETLReportingSetSimpleFieldReturnOptions.SPECIFIC_FIELD)) {
                this.selectFieldInitialValue();
            }
        } else {
            this.simpleFieldForm.patchValue({
                return: this.simpleFieldForm.get('return').value,
                JoinID: this.primaryFeedOptions[this.simpleFieldForm.get('JoinID').value.id]
            });
        }
    }

    selectFieldInitialValue() {
        this.secondaryFeedOptions.forEach((option: any) => {
            option.normalizedName = option.Name.replace(/_/g, '').toLowerCase();
        });

        this.secondaryFeedOptions.sort((a: any, b: any) => {
            return a.normalizedName.localeCompare(b.normalizedName);
        });
        // Clean up normalizedName property
        this.secondaryFeedOptions.forEach((option: any) => {
            delete option.normalizedName;
        });
        this.simpleFieldForm.get('Field').patchValue(this.secondaryFeedOptions[0]);
    }

    filterObjects(array, id) {
        return array.filter(obj => obj.DataType === id);
    }

    findObjectByJoinedFeedName(arr, joinedFeedName) {
        return arr.find(item => item.joinedFeedName === joinedFeedName) || null;
    }

    selectionChange($event: any) {
        this.IsNullControl.setValue(false);
        this.handleNullChange();
        this.initializeSimpleFeedObjectInOutputForm();
        if (this.simpleFieldReturnType === this.eReportingSetReturnTypes.DATE && $event.selected?.id === ETLReportingSetSimpleFieldReturnOptions.DEFAULT_VALUE) {
            const isDate = this.isValidDateObject(new Date(this.defaultDate));
            this.defaultDate = isDate ? this.defaultDate : new Date();
            this.simpleFieldForm.patchValue({ DefaultValue: this.defaultDate });
        }
        this.simpleFieldReturnType = this.simpleFieldForm.get('expectedReturnType').value.id;
        this.selectFeedSelection();
        this.handleDefaultValues();
        this.sendReturnTypeValue.emit(this.simpleFieldForm.value.expectedReturnType);
    }

    isValidDateObject(obj: any): boolean {
        return obj instanceof Date && !isNaN(obj.getTime());
    }

    returnTypeChangeEvent(item: any) {
        this.simpleFieldForm.get('expectedReturnType').patchValue(item.selected);
        this.simpleFieldReturnType = this.simpleFieldForm.get('expectedReturnType').value.id;
        this.selectFeedSelection();
        if (item.hasOwnProperty('isManual')) {
            if (this.return?.id !== ETLReportingSetSimpleFieldReturnOptions.DEFAULT_VALUE && this.parentData.simpleFieldType && this.parentData.simpleFieldType.Field) {
                this.simpleFieldForm.patchValue({
                    Field: this.parentData.simpleFieldType.Field
                });
            } else {
                this.simpleFieldForm.patchValue({
                    Field: this.secondaryFeedOptions[0]
                });
            }
        } else {
            this.selectFieldInitialValue();
        }
        let defaultValue = this.simpleFieldForm.get('DefaultValue').value;
        if (!defaultValue || defaultValue === 'undefined' || defaultValue === 'null') {
            if (this.simpleFieldReturnType === this.eReportingSetReturnTypes.TRUE_FALSE) {
                defaultValue = false;
                this.simpleFieldForm.patchValue({ DefaultValue: defaultValue });
            }
        }
        this.sendReturnTypeValue.emit(this.simpleFieldForm.value.expectedReturnType);
    }

    handleNullChange() {
        if (this.IsNull) {
            this.getDefaultValue("null");
            if (this.simpleFieldReturnType === this.eReportingSetReturnTypes.DATE) {
                this.isDisableDate = true;
                this.UseNowControl.disable();
            } else {
                this.defaultValueControl.disable();
                this.defaultValueControl.reset();
            }
        } else {
            if (this.simpleFieldReturnType === this.eReportingSetReturnTypes.DATE) {
                this.isDisableDate = false;
                if (!this.DisableEdit)
                    this.UseNowControl.enable();
                this.defaultValueControl.setValue("null");
            } else {
                if (!this.DisableEdit)
                    this.defaultValueControl.enable();
            }
            this.setDefaultValue();
        }
    }

    handleUseNowChange() {
        if (this.UseNow) {
            this.getDefaultValue("{{NOW}}");
            this.isDisableDate = true;
            if (!this.DisableEdit)
                this.IsNullControl?.disable();
        } else {
            this.isDisableDate = false;
            if (!this.DisableEdit)
                this.IsNullControl?.enable();
            this.setDefaultValue();
        }
    }

    getDefaultValue(value: "null" | "{{NOW}}") {
        if (this.simpleFieldReturnType === this.eReportingSetReturnTypes.DATE) {
            this.tempDefaultValue = this.defaultDate ?
                this.defaultDate :
                this._parentData.simpleFieldType.DefaultValue
            this.defaultValueControl.setValue(value);
        } else {
            this.tempDefaultValue = this.defaultValue ?
                this.defaultValue :
                this._parentData.simpleFieldType.DefaultValue;
        }
    }

    setDefaultValue() {
        if (this.simpleFieldReturnType === this.eReportingSetReturnTypes.DATE) {
            let defaultValue = this.tempDefaultValue ? new Date(this.tempDefaultValue) : new Date();
            this.defaultDate = defaultValue;
        }
        if (this.return?.id !== ETLReportingSetSimpleFieldReturnOptions.SPECIFIC_FIELD) {
            this.defaultValueControl.setValue(this.tempDefaultValue);
        }
    }

    toggleNullCheckbox() {
        this.IsNullControl.setValue(true);
    }

    toggleUseNowCheckbox() {
        this.UseNowControl.setValue(true);
    }

    customDefaultValueValidator(getLocalizationString: (key: string, defaultMessage: string) => string) {
        return (control: AbstractControl): ValidationErrors | null => {
            const value = control.value;
            if (value == 0 && this.employeeContactClickedField === HierarchyGroupName.COMPANY) {
                return { invalidValue: getLocalizationString("Error_Hierarchy_level", "The value for the highest level in the group cannot be zero.") };
            }
            return null;
        };
    }
}
